import { type PayloadAction } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import {
  type FetchingItemsState,
  createFetchingItemsSlice,
} from "features/Application/slices/createFetchingItemsSlice";
import { type EmbeddedVideoOverview } from "../types/models";

export interface EmbeddedVideosOverviewState extends FetchingItemsState<EmbeddedVideoOverview> {
  selected: number[];
}

export const initialState: EmbeddedVideosOverviewState = {
  isLoading: false,
  items: [],
  itemsCount: 0,
  selected: [],
};

const slice = createFetchingItemsSlice({
  initialState,
  namePayload: {
    entity: ReducerEntityPrefixTypes.EmbeddedVideos,
    name: "Overview",
    namespace: ReducerNamespaceTypes.Library,
  },
  reducers: {
    setSelected: (state, action: PayloadAction<number[]>) => {
      state.selected = action.payload;
    },
  },
});

export const { fetchBegin, fetchFailure, fetchSuccess, reset, setSelected } = slice.actions;

export default slice.reducer;
